module.exports = __webpack_public_path__ + "img/guanlishezhi.27ed9f0e.png";